import React, { useState } from 'react';

import PropTypes from 'prop-types';

import _get from 'lodash/get';
import { useSelector } from 'react-redux';

import { getLocationDescriptionPrompt } from './LocationDescriptionField.utils';
import ErrorHandler from '../../../../libs/errors';
import { selectBusinessId, selectBusinessType } from '../../../../selectors';
import MarkdownField from '../../../fields/MarkdownField';
import ActionsInput from '../../../modules/content/components/ActionsInput';
import WritingAssistantButton from '../../../modules/content/components/WritingAssistantButton';
import { getWritingAssistantActions } from '../../../modules/content/services/prompts';

import './LocationDescriptionField.scss';

const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const defaultProps = {
  value: '',
  locationId: null,
};

export default function LocationDescriptionField({ value, onChange, locationId }) {
  const businessId = useSelector(selectBusinessId);
  const businessType = useSelector(selectBusinessType);
  const [loading, setLoading] = useState(false);

  async function onMakeSuggestion() {
    try {
      setLoading(true);
      const params = { location_id: locationId };
      const { text_completion: generatedDescription } = await getLocationDescriptionPrompt(
        businessType,
        businessId,
        params,
      );
      return generatedDescription || '';
    } catch (error) {
      ErrorHandler.capture(error);
      return '';
    } finally {
      setLoading(false);
    }
  }

  function onDescriptionChange(eventOrValue, target) {
    const newValue = _get(target, 'value', target || eventOrValue);
    onChange(newValue);
  }

  return (
    <ActionsInput className="location-description-field">
      <ActionsInput.Input
        input={MarkdownField}
        value={value}
        onChange={onDescriptionChange}
        disabled={loading}
        loading={loading}
      />

      <ActionsInput.Actions
        trigger={WritingAssistantButton}
        actionSections={getWritingAssistantActions({ onMakeSuggestion })}
        intelligentWebsiteOnly
        disabled={loading || !locationId}
      />
    </ActionsInput>
  );
}

LocationDescriptionField.propTypes = propTypes;
LocationDescriptionField.defaultProps = defaultProps;
